// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ir-0";
export var actionModalContentContainer = "_ir-1";